var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProimage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    opacity: 0.4,
    d: "M38.0918 52.9722H15.1702C6.20626 52.9722 0.184326 46.6852 0.184326 37.3263V15.7247C0.184326 6.3658 6.20626 0.0761719 15.1702 0.0761719H38.0944C47.0584 0.0761719 53.0803 6.3658 53.0803 15.7247V37.3263C53.0803 46.6852 47.0584 52.9722 38.0918 52.9722",
    fill: "#42D27B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6355 17.7302C24.6355 21.3536 21.6865 24.3026 18.0632 24.3026C14.4371 24.3026 11.4908 21.3536 11.4908 17.7302C11.4908 14.1069 14.4371 11.1553 18.0632 11.1553C21.6865 11.1553 24.6355 14.1069 24.6355 17.7302ZM46.2049 32.0455C46.8211 32.6432 47.2628 33.3256 47.5537 34.0529C48.4344 36.2534 47.9769 38.8982 47.0353 41.0775C45.9192 43.6721 43.7822 45.6319 41.0898 46.4888C39.8944 46.8723 38.6407 47.0362 37.3897 47.0362H15.2237C13.0179 47.0362 11.066 46.5232 9.46594 45.5604C8.46356 44.9574 8.28636 43.5689 9.02955 42.6644C10.2726 41.1569 11.4998 39.644 12.7376 38.118C15.0967 35.1981 16.6862 34.3518 18.453 35.095C19.1697 35.4018 19.8891 35.8646 20.6296 36.3512C22.6027 37.6578 25.3453 39.451 28.9581 37.5044C31.4276 36.154 32.8611 33.8434 34.1089 31.8321L34.134 31.7916C34.218 31.657 34.3012 31.5225 34.3842 31.3884C34.8085 30.7028 35.2263 30.0276 35.6997 29.406C36.2869 28.6364 38.4662 26.2296 41.2829 27.9434C43.0787 29.0225 44.5889 30.4824 46.2049 32.0455Z",
    fill: "#42D27B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProimage);
export default __webpack_public_path__ + "static/media/proimage.24bcaf9a5e0fc5be2a85eeda9fee9a30.svg";
export { ForwardRef as ReactComponent };